import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteItem, fetchData, handleDragEnd, toggleStatus } from "../../../utils/apiUtils";
import DeleteModel from "../../../Components/DeleteModel";
import { ActionButton, checkImage, PlusButton, ToggleSwitch } from "../../../helper/ImageFormat";
import CustomPagination from "../../../helper/Pagination";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Breadcrumb from "../../../helper/Breadcrumb";
import Spinner from "../../../Components/spinner";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import dateformate from "../../../helper/DateFormate";

const HomeBanner = () => {
  const [loading, setLoading] = useState(false);
  const [sliderData, setSliderData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [nextPosition, setNextPosition] = useState(0);
  const navigator = useNavigate();
   const [search, setSearch] = useState("");

  const fetchHomeBanner = async (page = 1, searchQuery = "") => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      search: searchQuery,
    };
    await fetchData(
      "homebanner-pagination",
      requestData,
      setSliderData,
      setTotalCount,
      setCurrentPage,
      setLoading,
      setNextPosition

    );
  };

   useEffect(() => {
          const delay = search ? 500 : 0;
          const handler = setTimeout(() => {
          fetchHomeBanner(currentPage, search);
          }, delay);
          return () => clearTimeout(handler);
      }, [search, perPage]);


  


  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchHomeBanner(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("homebanner", deleteItemId?.id, fetchHomeBanner,[deleteItemId?.desktopImage, deleteItemId?.mobileImage].filter(Boolean));
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };


  const handleStatusToggle = async (item) => {
    const data = await toggleStatus(
      "homebanner-status",
      item?.id,
      fetchHomeBanner
    );
    if (Object.keys(data).length > 0) {
      setSliderData((prevdata) =>
        prevdata.map((curr) =>
          curr.id === data.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };
  const handleOnDragEnd = (result) => {
    handleDragEnd({
      result,
      data: sliderData,
      setData: setSliderData,
      apiEndpoint: "/homebanner-position",
    });
  };

  const handleAdd = () => {  
    navigator("/add-home-banner",{state:{nextPosition}});
  };
  const handleEditClick = (item) => {
    navigator("/add-home-banner", {
      state: item,
    });
  };

  const Tableheader = [
    "Banner Type",
    "Desktop Img",
    "Mobile Img",
    "Updated At",
    "Is Active",
    "Action",
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Home-Banners", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Home Banners</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="d-flex justify-content-between mb-2 bg-white p-2" style={{ marginTop: "-20px" }}>
            <PerPageSelect value={perPage} onChange={setPerPage}/>
                <div style={{ display: "flex", gap: "10px" }}>
            <TableSearch value={search} onChange={setSearch} />
          <PlusButton handleAdd={handleAdd} module={"Home Banners"} />
                </div>
        </div>
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="sliders">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="table-responsive"
                      >
                        <table
                          className=" custom-table table table-striped"
                          id="slidertable"
                        >
                          <thead>
                            <tr>
                              <th className="font-weight-bold ">Sort Order</th>
                              {Tableheader.map((item, index) => (
                                <th className="font-weight-bold " key={index}>
                                  {item}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <Spinner />
                                </td>
                              </tr>
                            ) : sliderData?.length > 0 ? (
                              sliderData.map((item, index) => (
                                <Draggable
                                  key={item.id}
                                  draggableId={item.id.toString()}
                                  index={index}
                                >
                                  {(provided) => (
                                    <tr
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      ref={provided.innerRef}
                                    >
                                      <td>{item.position}</td>
                                      <td >{item.title}</td>
                                      <td >
                                        {checkImage(item.desktopImage)}
                                      </td>
                                      <td >
                                        {checkImage(item?.mobileImage)}
                                      </td>
                                      <td>{dateformate(item.updatedAt)}</td>
                                      {/* <td>{dateformate(item.createdAt)}</td> */}
                                      <td>
                                        <ToggleSwitch
                                          data={item}
                                          name="isActive"
                                          checked={item.isActive}
                                          handleStatusToggle={handleStatusToggle}
                                          module={"Home Banners"}
                                        />
                                      </td>
                                      <td>
                                        <ActionButton
                                          data={item}
                                          handleEditClick={handleEditClick}
                                          handleDelete={handleDelete}
                                          module={"Home Banners"}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                </Draggable>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <h5>No data found.</h5>
                                </td>
                              </tr>
                            )}

                            {provided.placeholder}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
                {sliderData?.length > 0 && (
                  <div>
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="home banners"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default HomeBanner;
